import { useId } from 'react';
import { useStore } from 'zustand';
import Tooltip from '../ui/Tooltip';
import { getStoreByKey } from './store/CarouselStore';

interface Props {
  label: string;
  children: React.ReactNode;
  tooltip?: string;
  className?: string;
  uniqId: string;
}

const CarouselCardRow = ({
  label,
  children,
  tooltip,
  className = '',
  uniqId,
}: Props) => {
  const { options } = useStore(getStoreByKey(uniqId));
  const id = useId();
  return (
    <div
      className={`flex flex-col gap-1 py-2 text-sm px-1 ${!options ? 'border-b' : ''} ${className}`}
    >
      <h5 className="flex gap-2 items-center text-[14px] font-semibold mb-0">
        {label}
        {tooltip ? (
          <Tooltip describe={`tooltip-${id}`}>{tooltip}</Tooltip>
        ) : null}
      </h5>
      <>{children}</>
    </div>
  );
};

export default CarouselCardRow;
